<script setup lang="ts">
// Histórico de Poker do Minha Conta V2 (ENG-362). A página antiga
// (pages/user/history/poker.vue) não consome nenhuma API — só exibe o aviso
// "Em breve" (o extrato de poker ainda não existe no BFF; a tabela de
// transações está comentada lá). Aqui reproduzimos o mesmo aviso no padrão V2.
</script>

<template>
  <div
    class="border-solid flex w-full items-center gap-[12px] rounded-[16px] border border-v2-warning/40 bg-v2-warning/20 p-[16px]"
  >
    <span
      class="flex size-[32px] shrink-0 items-center justify-center rounded-full bg-v2-warning/20 text-v2-warning"
    >
      <svg
        class="size-[16px]"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        viewBox="0 0 24 24"
      >
        <path d="M12 8v4m0 4h.01M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z" />
      </svg>
    </span>
    <p
      class="text-[12px] leading-[16px] text-v2-foreground"
      v-html="$t('account_menu.soon')"
    />
  </div>
</template>
